<template>

    <div class="my-icon-picker" :class="{'use-as-togglebox': asToggleBoxUse}" @click="toggleIcons" ref="iconPicker">

        <div class="search-filter-input">

            <b-form-input  v-model="searchTerm" type="text" placeholder="Search icon" size="sm" />

            <div class="active-icon" v-b-tooltip.hover.top title="Your selected icon">

                <i :class="selectedIcon"></i>

            </div>

        </div>

        <div class="my-icon-picker--icons">

            <i v-for="(icon, index) in filteredIcons" :key="index" :class="[{ 'active': icon.name === selectedIcon }, icon.name]" @click="selectIcon"></i>

        </div>

    </div>

</template>



<script>

export default {

    props: ['setActiveIcon','asToggleBox'],

    name: 'MyIconPicker',

    data() {

        return{

            selectedIcon : '',
            // list of all icons in FA version 5.7.2
            icons : [
                {name : "fab fa-500px"} ,
                {name : "fab fa-accessible-icon"} ,
                {name : "fab fa-accusoft"} ,
                {name : "fab fa-acquisitions-incorporated"} ,
                {name : "fas fa-ad"} ,
                {name : "fas fa-address-book"} ,
                {name : "far fa-address-book"} ,
                {name : "fas fa-address-card"} ,
                {name : "far fa-address-card"} ,
                {name : "fas fa-adjust"} ,
                {name : "fab fa-adn"} ,
                {name : "fab fa-adobe"} ,
                {name : "fab fa-adversal"} ,
                {name : "fab fa-affiliatetheme"} ,
                {name : "fas fa-air-freshener"} ,
                {name : "fab fa-algolia"} ,
                {name : "fas fa-align-center"} ,
                {name : "fas fa-align-justify"} ,
                {name : "fas fa-align-left"} ,
                {name : "fas fa-align-right"} ,
                {name : "fab fa-alipay"} ,
                {name : "fas fa-allergies"} ,
                {name : "fab fa-amazon"} ,
                {name : "fab fa-amazon-pay"} ,
                {name : "fas fa-ambulance"} ,
                {name : "fas fa-american-sign-language-interpreting"} ,
                {name : "fab fa-amilia"} ,
                {name : "fas fa-anchor"} ,
                {name : "fab fa-android"} ,
                {name : "fab fa-angellist"} ,
                {name : "fas fa-angle-double-down"} ,
                {name : "fas fa-angle-double-left"} ,
                {name : "fas fa-angle-double-right"} ,
                {name : "fas fa-angle-double-up"} ,
                {name : "fas fa-angle-down"} ,
                {name : "fas fa-angle-left"} ,
                {name : "fas fa-angle-right"} ,
                {name : "fas fa-angle-up"} ,
                {name : "fas fa-angry"} ,
                {name : "far fa-angry"} ,
                {name : "fab fa-angrycreative"} ,
                {name : "fab fa-angular"} ,
                {name : "fas fa-ankh"} ,
                {name : "fab fa-app-store"} ,
                {name : "fab fa-app-store-ios"} ,
                {name : "fab fa-apper"} ,
                {name : "fab fa-apple"} ,
                {name : "fas fa-apple-alt"} ,
                {name : "fab fa-apple-pay"} ,
                {name : "fas fa-archive"} ,
                {name : "fas fa-archway"} ,
                {name : "fas fa-arrow-alt-circle-down"} ,
                {name : "far fa-arrow-alt-circle-down"} ,
                {name : "fas fa-arrow-alt-circle-left"} ,
                {name : "far fa-arrow-alt-circle-left"} ,
                {name : "fas fa-arrow-alt-circle-right"} ,
                {name : "far fa-arrow-alt-circle-right"} ,
                {name : "fas fa-arrow-alt-circle-up"} ,
                {name : "far fa-arrow-alt-circle-up"} ,
                {name : "fas fa-arrow-circle-down"} ,
                {name : "fas fa-arrow-circle-left"} ,
                {name : "fas fa-arrow-circle-right"} ,
                {name : "fas fa-arrow-circle-up"} ,
                {name : "fas fa-arrow-down"} ,
                {name : "fas fa-arrow-left"} ,
                {name : "fas fa-arrow-right"} ,
                {name : "fas fa-arrow-up"} ,
                {name : "fas fa-arrows-alt"} ,
                {name : "fas fa-arrows-alt-h"} ,
                {name : "fas fa-arrows-alt-v"} ,
                {name : "fab fa-artstation"} ,
                {name : "fas fa-assistive-listening-systems"} ,
                {name : "fas fa-asterisk"} ,
                {name : "fab fa-asymmetrik"} ,
                {name : "fas fa-at"} ,
                {name : "fas fa-atlas"} ,
                {name : "fab fa-atlassian"} ,
                {name : "fas fa-atom"} ,
                {name : "fab fa-audible"} ,
                {name : "fas fa-audio-description"} ,
                {name : "fab fa-autoprefixer"} ,
                {name : "fab fa-avianex"} ,
                {name : "fab fa-aviato"} ,
                {name : "fas fa-award"} ,
                {name : "fab fa-aws"} ,
                {name : "fas fa-baby"} ,
                {name : "fas fa-baby-carriage"} ,
                {name : "fas fa-backspace"} ,
                {name : "fas fa-backward"} ,
                {name : "fas fa-bacon"} ,
                {name : "fas fa-balance-scale"} ,
                {name : "fas fa-ban"} ,
                {name : "fas fa-band-aid"} ,
                {name : "fab fa-bandcamp"} ,
                {name : "fas fa-barcode"} ,
                {name : "fas fa-bars"} ,
                {name : "fas fa-baseball-ball"} ,
                {name : "fas fa-basketball-ball"} ,
                {name : "fas fa-bath"} ,
                {name : "fas fa-battery-empty"} ,
                {name : "fas fa-battery-full"} ,
                {name : "fas fa-battery-half"} ,
                {name : "fas fa-battery-quarter"} ,
                {name : "fas fa-battery-three-quarters"} ,
                {name : "fas fa-bed"} ,
                {name : "fas fa-beer"} ,
                {name : "fab fa-behance"} ,
                {name : "fab fa-behance-square"} ,
                {name : "fas fa-bell"} ,
                {name : "far fa-bell"} ,
                {name : "fas fa-bell-slash"} ,
                {name : "far fa-bell-slash"} ,
                {name : "fas fa-bezier-curve"} ,
                {name : "fas fa-bible"} ,
                {name : "fas fa-bicycle"} ,
                {name : "fab fa-bimobject"} ,
                {name : "fas fa-binoculars"} ,
                {name : "fas fa-biohazard"} ,
                {name : "fas fa-birthday-cake"} ,
                {name : "fab fa-bitbucket"} ,
                {name : "fab fa-bitcoin"} ,
                {name : "fab fa-bity"} ,
                {name : "fab fa-black-tie"} ,
                {name : "fab fa-blackberry"} ,
                {name : "fas fa-blender"} ,
                {name : "fas fa-blender-phone"} ,
                {name : "fas fa-blind"} ,
                {name : "fas fa-blog"} ,
                {name : "fab fa-blogger"} ,
                {name : "fab fa-blogger-b"} ,
                {name : "fab fa-bluetooth"} ,
                {name : "fab fa-bluetooth-b"} ,
                {name : "fas fa-bold"} ,
                {name : "fas fa-bolt"} ,
                {name : "fas fa-bomb"} ,
                {name : "fas fa-bone"} ,
                {name : "fas fa-bong"} ,
                {name : "fas fa-book"} ,
                {name : "fas fa-book-dead"} ,
                {name : "fas fa-book-medical"} ,
                {name : "fas fa-book-open"} ,
                {name : "fas fa-book-reader"} ,
                {name : "fas fa-bookmark"} ,
                {name : "far fa-bookmark"} ,
                {name : "fas fa-bowling-ball"} ,
                {name : "fas fa-box"} ,
                {name : "fas fa-box-open"} ,
                {name : "fas fa-boxes"} ,
                {name : "fas fa-braille"} ,
                {name : "fas fa-brain"} ,
                {name : "fas fa-bread-slice"} ,
                {name : "fas fa-briefcase"} ,
                {name : "fas fa-briefcase-medical"} ,
                {name : "fas fa-broadcast-tower"} ,
                {name : "fas fa-broom"} ,
                {name : "fas fa-brush"} ,
                {name : "fab fa-btc"} ,
                {name : "fas fa-bug"} ,
                {name : "fas fa-building"} ,
                {name : "far fa-building"} ,
                {name : "fas fa-bullhorn"} ,
                {name : "fas fa-bullseye"} ,
                {name : "fas fa-burn"} ,
                {name : "fab fa-buromobelexperte"} ,
                {name : "fas fa-bus"} ,
                {name : "fas fa-bus-alt"} ,
                {name : "fas fa-business-time"} ,
                {name : "fab fa-buysellads"} ,
                {name : "fas fa-calculator"} ,
                {name : "fas fa-calendar"} ,
                {name : "far fa-calendar"} ,
                {name : "fas fa-calendar-alt"} ,
                {name : "far fa-calendar-alt"} ,
                {name : "fas fa-calendar-check"} ,
                {name : "far fa-calendar-check"} ,
                {name : "fas fa-calendar-day"} ,
                {name : "fas fa-calendar-minus"} ,
                {name : "far fa-calendar-minus"} ,
                {name : "fas fa-calendar-plus"} ,
                {name : "far fa-calendar-plus"} ,
                {name : "fas fa-calendar-times"} ,
                {name : "far fa-calendar-times"} ,
                {name : "fas fa-calendar-week"} ,
                {name : "fas fa-camera"} ,
                {name : "fas fa-camera-retro"} ,
                {name : "fas fa-campground"} ,
                {name : "fab fa-canadian-maple-leaf"} ,
                {name : "fas fa-candy-cane"} ,
                {name : "fas fa-cannabis"} ,
                {name : "fas fa-capsules"} ,
                {name : "fas fa-car"} ,
                {name : "fas fa-car-alt"} ,
                {name : "fas fa-car-battery"} ,
                {name : "fas fa-car-crash"} ,
                {name : "fas fa-car-side"} ,
                {name : "fas fa-caret-down"} ,
                {name : "fas fa-caret-left"} ,
                {name : "fas fa-caret-right"} ,
                {name : "fas fa-caret-square-down"} ,
                {name : "far fa-caret-square-down"} ,
                {name : "fas fa-caret-square-left"} ,
                {name : "far fa-caret-square-left"} ,
                {name : "fas fa-caret-square-right"} ,
                {name : "far fa-caret-square-right"} ,
                {name : "fas fa-caret-square-up"} ,
                {name : "far fa-caret-square-up"} ,
                {name : "fas fa-caret-up"} ,
                {name : "fas fa-carrot"} ,
                {name : "fas fa-cart-arrow-down"} ,
                {name : "fas fa-cart-plus"} ,
                {name : "fas fa-cash-register"} ,
                {name : "fas fa-cat"} ,
                {name : "fab fa-cc-amazon-pay"} ,
                {name : "fab fa-cc-amex"} ,
                {name : "fab fa-cc-apple-pay"} ,
                {name : "fab fa-cc-diners-club"} ,
                {name : "fab fa-cc-discover"} ,
                {name : "fab fa-cc-jcb"} ,
                {name : "fab fa-cc-mastercard"} ,
                {name : "fab fa-cc-paypal"} ,
                {name : "fab fa-cc-stripe"} ,
                {name : "fab fa-cc-visa"} ,
                {name : "fab fa-centercode"} ,
                {name : "fab fa-centos"} ,
                {name : "fas fa-certificate"} ,
                {name : "fas fa-chair"} ,
                {name : "fas fa-chalkboard"} ,
                {name : "fas fa-chalkboard-teacher"} ,
                {name : "fas fa-charging-station"} ,
                {name : "fas fa-chart-area"} ,
                {name : "fas fa-chart-bar"} ,
                {name : "far fa-chart-bar"} ,
                {name : "fas fa-chart-line"} ,
                {name : "fas fa-chart-pie"} ,
                {name : "fas fa-check"} ,
                {name : "fas fa-check-circle"} ,
                {name : "far fa-check-circle"} ,
                {name : "fas fa-check-double"} ,
                {name : "fas fa-check-square"} ,
                {name : "far fa-check-square"} ,
                {name : "fas fa-cheese"} ,
                {name : "fas fa-chess"} ,
                {name : "fas fa-chess-bishop"} ,
                {name : "fas fa-chess-board"} ,
                {name : "fas fa-chess-king"} ,
                {name : "fas fa-chess-knight"} ,
                {name : "fas fa-chess-pawn"} ,
                {name : "fas fa-chess-queen"} ,
                {name : "fas fa-chess-rook"} ,
                {name : "fas fa-chevron-circle-down"} ,
                {name : "fas fa-chevron-circle-left"} ,
                {name : "fas fa-chevron-circle-right"} ,
                {name : "fas fa-chevron-circle-up"} ,
                {name : "fas fa-chevron-down"} ,
                {name : "fas fa-chevron-left"} ,
                {name : "fas fa-chevron-right"} ,
                {name : "fas fa-chevron-up"} ,
                {name : "fas fa-child"} ,
                {name : "fab fa-chrome"} ,
                {name : "fas fa-church"} ,
                {name : "fas fa-circle"} ,
                {name : "far fa-circle"} ,
                {name : "fas fa-circle-notch"} ,
                {name : "fas fa-city"} ,
                {name : "fas fa-clinic-medical"} ,
                {name : "fas fa-clipboard"} ,
                {name : "far fa-clipboard"} ,
                {name : "fas fa-clipboard-check"} ,
                {name : "fas fa-clipboard-list"} ,
                {name : "fas fa-clock"} ,
                {name : "far fa-clock"} ,
                {name : "fas fa-clone"} ,
                {name : "far fa-clone"} ,
                {name : "fas fa-closed-captioning"} ,
                {name : "far fa-closed-captioning"} ,
                {name : "fas fa-cloud"} ,
                {name : "fas fa-cloud-download-alt"} ,
                {name : "fas fa-cloud-meatball"} ,
                {name : "fas fa-cloud-moon"} ,
                {name : "fas fa-cloud-moon-rain"} ,
                {name : "fas fa-cloud-rain"} ,
                {name : "fas fa-cloud-showers-heavy"} ,
                {name : "fas fa-cloud-sun"} ,
                {name : "fas fa-cloud-sun-rain"} ,
                {name : "fas fa-cloud-upload-alt"} ,
                {name : "fab fa-cloudscale"} ,
                {name : "fab fa-cloudsmith"} ,
                {name : "fab fa-cloudversify"} ,
                {name : "fas fa-cocktail"} ,
                {name : "fas fa-code"} ,
                {name : "fas fa-code-branch"} ,
                {name : "fab fa-codepen"} ,
                {name : "fab fa-codiepie"} ,
                {name : "fas fa-coffee"} ,
                {name : "fas fa-cog"} ,
                {name : "fas fa-cogs"} ,
                {name : "fas fa-coins"} ,
                {name : "fas fa-columns"} ,
                {name : "fas fa-comment"} ,
                {name : "far fa-comment"} ,
                {name : "fas fa-comment-alt"} ,
                {name : "far fa-comment-alt"} ,
                {name : "fas fa-comment-dollar"} ,
                {name : "fas fa-comment-dots"} ,
                {name : "far fa-comment-dots"} ,
                {name : "fas fa-comment-medical"} ,
                {name : "fas fa-comment-slash"} ,
                {name : "fas fa-comments"} ,
                {name : "far fa-comments"} ,
                {name : "fas fa-comments-dollar"} ,
                {name : "fas fa-compact-disc"} ,
                {name : "fas fa-compass"} ,
                {name : "far fa-compass"} ,
                {name : "fas fa-compress"} ,
                {name : "fas fa-compress-arrows-alt"} ,
                {name : "fas fa-concierge-bell"} ,
                {name : "fab fa-confluence"} ,
                {name : "fab fa-connectdevelop"} ,
                {name : "fab fa-contao"} ,
                {name : "fas fa-cookie"} ,
                {name : "fas fa-cookie-bite"} ,
                {name : "fas fa-copy"} ,
                {name : "far fa-copy"} ,
                {name : "fas fa-copyright"} ,
                {name : "far fa-copyright"} ,
                {name : "fas fa-couch"} ,
                {name : "fab fa-cpanel"} ,
                {name : "fab fa-creative-commons"} ,
                {name : "fab fa-creative-commons-by"} ,
                {name : "fab fa-creative-commons-nc"} ,
                {name : "fab fa-creative-commons-nc-eu"} ,
                {name : "fab fa-creative-commons-nc-jp"} ,
                {name : "fab fa-creative-commons-nd"} ,
                {name : "fab fa-creative-commons-pd"} ,
                {name : "fab fa-creative-commons-pd-alt"} ,
                {name : "fab fa-creative-commons-remix"} ,
                {name : "fab fa-creative-commons-sa"} ,
                {name : "fab fa-creative-commons-sampling"} ,
                {name : "fab fa-creative-commons-sampling-plus"} ,
                {name : "fab fa-creative-commons-share"} ,
                {name : "fab fa-creative-commons-zero"} ,
                {name : "fas fa-credit-card"} ,
                {name : "far fa-credit-card"} ,
                {name : "fab fa-critical-role"} ,
                {name : "fas fa-crop"} ,
                {name : "fas fa-crop-alt"} ,
                {name : "fas fa-cross"} ,
                {name : "fas fa-crosshairs"} ,
                {name : "fas fa-crow"} ,
                {name : "fas fa-crown"} ,
                {name : "fas fa-crutch"} ,
                {name : "fab fa-css3"} ,
                {name : "fab fa-css3-alt"} ,
                {name : "fas fa-cube"} ,
                {name : "fas fa-cubes"} ,
                {name : "fas fa-cut"} ,
                {name : "fab fa-cuttlefish"} ,
                {name : "fab fa-d-and-d"} ,
                {name : "fab fa-d-and-d-beyond"} ,
                {name : "fab fa-dashcube"} ,
                {name : "fas fa-database"} ,
                {name : "fas fa-deaf"} ,
                {name : "fab fa-delicious"} ,
                {name : "fas fa-democrat"} ,
                {name : "fab fa-deploydog"} ,
                {name : "fab fa-deskpro"} ,
                {name : "fas fa-desktop"} ,
                {name : "fab fa-dev"} ,
                {name : "fab fa-deviantart"} ,
                {name : "fas fa-dharmachakra"} ,
                {name : "fab fa-dhl"} ,
                {name : "fas fa-diagnoses"} ,
                {name : "fab fa-diaspora"} ,
                {name : "fas fa-dice"} ,
                {name : "fas fa-dice-d20"} ,
                {name : "fas fa-dice-d6"} ,
                {name : "fas fa-dice-five"} ,
                {name : "fas fa-dice-four"} ,
                {name : "fas fa-dice-one"} ,
                {name : "fas fa-dice-six"} ,
                {name : "fas fa-dice-three"} ,
                {name : "fas fa-dice-two"} ,
                {name : "fab fa-digg"} ,
                {name : "fab fa-digital-ocean"} ,
                {name : "fas fa-digital-tachograph"} ,
                {name : "fas fa-directions"} ,
                {name : "fab fa-discord"} ,
                {name : "fab fa-discourse"} ,
                {name : "fas fa-divide"} ,
                {name : "fas fa-dizzy"} ,
                {name : "far fa-dizzy"} ,
                {name : "fas fa-dna"} ,
                {name : "fab fa-dochub"} ,
                {name : "fab fa-docker"} ,
                {name : "fas fa-dog"} ,
                {name : "fas fa-dollar-sign"} ,
                {name : "fas fa-dolly"} ,
                {name : "fas fa-dolly-flatbed"} ,
                {name : "fas fa-donate"} ,
                {name : "fas fa-door-closed"} ,
                {name : "fas fa-door-open"} ,
                {name : "fas fa-dot-circle"} ,
                {name : "far fa-dot-circle"} ,
                {name : "fas fa-dove"} ,
                {name : "fas fa-download"} ,
                {name : "fab fa-draft2digital"} ,
                {name : "fas fa-drafting-compass"} ,
                {name : "fas fa-dragon"} ,
                {name : "fas fa-draw-polygon"} ,
                {name : "fab fa-dribbble"} ,
                {name : "fab fa-dribbble-square"} ,
                {name : "fab fa-dropbox"} ,
                {name : "fas fa-drum"} ,
                {name : "fas fa-drum-steelpan"} ,
                {name : "fas fa-drumstick-bite"} ,
                {name : "fab fa-drupal"} ,
                {name : "fas fa-dumbbell"} ,
                {name : "fas fa-dumpster"} ,
                {name : "fas fa-dumpster-fire"} ,
                {name : "fas fa-dungeon"} ,
                {name : "fab fa-dyalog"} ,
                {name : "fab fa-earlybirds"} ,
                {name : "fab fa-ebay"} ,
                {name : "fab fa-edge"} ,
                {name : "fas fa-edit"} ,
                {name : "far fa-edit"} ,
                {name : "fas fa-egg"} ,
                {name : "fas fa-eject"} ,
                {name : "fab fa-elementor"} ,
                {name : "fas fa-ellipsis-h"} ,
                {name : "fas fa-ellipsis-v"} ,
                {name : "fab fa-ello"} ,
                {name : "fab fa-ember"} ,
                {name : "fab fa-empire"} ,
                {name : "fas fa-envelope"} ,
                {name : "far fa-envelope"} ,
                {name : "fas fa-envelope-open"} ,
                {name : "far fa-envelope-open"} ,
                {name : "fas fa-envelope-open-text"} ,
                {name : "fas fa-envelope-square"} ,
                {name : "fab fa-envira"} ,
                {name : "fas fa-equals"} ,
                {name : "fas fa-eraser"} ,
                {name : "fab fa-erlang"} ,
                {name : "fab fa-ethereum"} ,
                {name : "fas fa-ethernet"} ,
                {name : "fab fa-etsy"} ,
                {name : "fas fa-euro-sign"} ,
                {name : "fas fa-exchange-alt"} ,
                {name : "fas fa-exclamation"} ,
                {name : "fas fa-exclamation-circle"} ,
                {name : "fas fa-exclamation-triangle"} ,
                {name : "fas fa-expand"} ,
                {name : "fas fa-expand-arrows-alt"} ,
                {name : "fab fa-expeditedssl"} ,
                {name : "fas fa-external-link-alt"} ,
                {name : "fas fa-external-link-square-alt"} ,
                {name : "fas fa-eye"} ,
                {name : "far fa-eye"} ,
                {name : "fas fa-eye-dropper"} ,
                {name : "fas fa-eye-slash"} ,
                {name : "far fa-eye-slash"} ,
                {name : "fab fa-facebook"} ,
                {name : "fab fa-facebook-f"} ,
                {name : "fab fa-facebook-messenger"} ,
                {name : "fab fa-facebook-square"} ,
                {name : "fab fa-fantasy-flight-games"} ,
                {name : "fas fa- {name : fast-backward"} ,
                {name : "fas fa- {name : fast-forward"} ,
                {name : "fas fa-fax"} ,
                {name : "fas fa-feather"} ,
                {name : "fas fa-feather-alt"} ,
                {name : "fab fa-fedex"} ,
                {name : "fab fa-fedora"} ,
                {name : "fas fa-female"} ,
                {name : "fas fa-fighter-jet"} ,
                {name : "fab fa-figma"} ,
                {name : "fas fa-file"} ,
                {name : "far fa-file"} ,
                {name : "fas fa-file-alt"} ,
                {name : "far fa-file-alt"} ,
                {name : "fas fa-file-archive"} ,
                {name : "far fa-file-archive"} ,
                {name : "fas fa-file-audio"} ,
                {name : "far fa-file-audio"} ,
                {name : "fas fa-file-code"} ,
                {name : "far fa-file-code"} ,
                {name : "fas fa-file-contract"} ,
                {name : "fas fa-file-csv"} ,
                {name : "fas fa-file-download"} ,
                {name : "fas fa-file-excel"} ,
                {name : "far fa-file-excel"} ,
                {name : "fas fa-file-export"} ,
                {name : "fas fa-file-image"} ,
                {name : "far fa-file-image"} ,
                {name : "fas fa-file-import"} ,
                {name : "fas fa-file-invoice"} ,
                {name : "fas fa-file-invoice-dollar"} ,
                {name : "fas fa-file-medical"} ,
                {name : "fas fa-file-medical-alt"} ,
                {name : "fas fa-file-pdf"} ,
                {name : "far fa-file-pdf"} ,
                {name : "fas fa-file-powerpoint"} ,
                {name : "far fa-file-powerpoint"} ,
                {name : "fas fa-file-prescription"} ,
                {name : "fas fa-file-signature"} ,
                {name : "fas fa-file-upload"} ,
                {name : "fas fa-file-video"} ,
                {name : "far fa-file-video"} ,
                {name : "fas fa-file-word"} ,
                {name : "far fa-file-word"} ,
                {name : "fas fa-fill"} ,
                {name : "fas fa-fill-drip"} ,
                {name : "fas fa-film"} ,
                {name : "fas fa-filter"} ,
                {name : "fas fa-fingerprint"} ,
                {name : "fas fa-fire"} ,
                {name : "fas fa-fire-alt"} ,
                {name : "fas fa-fire-extinguisher"} ,
                {name : "fab fa-firefox"} ,
                {name : "fas fa-first-aid"} ,
                {name : "fab fa-first-order"} ,
                {name : "fab fa-first-order-alt"} ,
                {name : "fab fa-firstdraft"} ,
                {name : "fas fa-fish"} ,
                {name : "fas fa-fist-raised"} ,
                {name : "fas fa-flag"} ,
                {name : "far fa-flag"} ,
                {name : "fas fa-flag-checkered"} ,
                {name : "fas fa-flag-usa"} ,
                {name : "fas fa-flask"} ,
                {name : "fab fa-flickr"} ,
                {name : "fab fa-flipboard"} ,
                {name : "fas fa-flushed"} ,
                {name : "far fa-flushed"} ,
                {name : "fab fa-fly"} ,
                {name : "fas fa-folder"} ,
                {name : "far fa-folder"} ,
                {name : "fas fa-folder-minus"} ,
                {name : "fas fa-folder-open"} ,
                {name : "far fa-folder-open"} ,
                {name : "fas fa-folder-plus"} ,
                {name : "fas fa-font"} ,
                {name : "fab fa-font-awesome"} ,
                {name : "fab fa-font-awesome-alt"} ,
                {name : "fab fa-font-awesome-flag"} ,
                {name : "fab fa-fonticons"} ,
                {name : "fab fa-fonticons-fi"} ,
                {name : "fas fa-football-ball"} ,
                {name : "fab fa-fort-awesome"} ,
                {name : "fab fa-fort-awesome-alt"} ,
                {name : "fab fa-forumbee"} ,
                {name : "fas fa-forward"} ,
                {name : "fab fa-foursquare"} ,
                {name : "fab fa-free-code-camp"} ,
                {name : "fab fa-freebsd"} ,
                {name : "fas fa-frog"} ,
                {name : "fas fa-frown"} ,
                {name : "far fa-frown"} ,
                {name : "fas fa-frown-open"} ,
                {name : "far fa-frown-open"} ,
                {name : "fab fa-fulcrum"} ,
                {name : "fas fa-funnel-dollar"} ,
                {name : "fas fa-futbol"} ,
                {name : "far fa-futbol"} ,
                {name : "fab fa-galactic-republic"} ,
                {name : "fab fa-galactic-senate"} ,
                {name : "fas fa-gamepad"} ,
                {name : "fas fa-gas-pump"} ,
                {name : "fas fa-gavel"} ,
                {name : "fas fa-gem"} ,
                {name : "far fa-gem"} ,
                {name : "fas fa-genderless"} ,
                {name : "fab fa-get-pocket"} ,
                {name : "fab fa-gg"} ,
                {name : "fab fa-gg-circle"} ,
                {name : "fas fa-ghost"} ,
                {name : "fas fa-gift"} ,
                {name : "fas fa-gifts"} ,
                {name : "fab fa-git"} ,
                {name : "fab fa-git-square"} ,
                {name : "fab fa-github"} ,
                {name : "fab fa-github-alt"} ,
                {name : "fab fa-github-square"} ,
                {name : "fab fa-gitkraken"} ,
                {name : "fab fa-gitlab"} ,
                {name : "fab fa-gitter"} ,
                {name : "fas fa-glass-cheers"} ,
                {name : "fas fa-glass-martini"} ,
                {name : "fas fa-glass-martini-alt"} ,
                {name : "fas fa-glass-whiskey"} ,
                {name : "fas fa-glasses"} ,
                {name : "fab fa-glide"} ,
                {name : "fab fa-glide-g"} ,
                {name : "fas fa-globe"} ,
                {name : "fas fa-globe-africa"} ,
                {name : "fas fa-globe-americas"} ,
                {name : "fas fa-globe-asia"} ,
                {name : "fas fa-globe-europe"} ,
                {name : "fab fa-gofore"} ,
                {name : "fas fa-golf-ball"} ,
                {name : "fab fa-goodreads"} ,
                {name : "fab fa-goodreads-g"} ,
                {name : "fab fa-google"} ,
                {name : "fab fa-google-drive"} ,
                {name : "fab fa-google-play"} ,
                {name : "fab fa-google-plus"} ,
                {name : "fab fa-google-plus-g"} ,
                {name : "fab fa-google-plus-square"} ,
                {name : "fab fa-google-wallet"} ,
                {name : "fas fa-gopuram"} ,
                {name : "fas fa-graduation-cap"} ,
                {name : "fab fa-gratipay"} ,
                {name : "fab fa-grav"} ,
                {name : "fas fa-greater-than"} ,
                {name : "fas fa-greater-than-equal"} ,
                {name : "fas fa-grimace"} ,
                {name : "far fa-grimace"} ,
                {name : "fas fa-grin"} ,
                {name : "far fa-grin"} ,
                {name : "fas fa-grin-alt"} ,
                {name : "far fa-grin-alt"} ,
                {name : "fas fa-grin-beam"} ,
                {name : "far fa-grin-beam"} ,
                {name : "fas fa-grin-beam-sweat"} ,
                {name : "far fa-grin-beam-sweat"} ,
                {name : "fas fa-grin-hearts"} ,
                {name : "far fa-grin-hearts"} ,
                {name : "fas fa-grin-squint"} ,
                {name : "far fa-grin-squint"} ,
                {name : "fas fa-grin-squint-tears"} ,
                {name : "far fa-grin-squint-tears"} ,
                {name : "fas fa-grin-stars"} ,
                {name : "far fa-grin-stars"} ,
                {name : "fas fa-grin-tears"} ,
                {name : "far fa-grin-tears"} ,
                {name : "fas fa-grin-tongue"} ,
                {name : "far fa-grin-tongue"} ,
                {name : "fas fa-grin-tongue-squint"} ,
                {name : "far fa-grin-tongue-squint"} ,
                {name : "fas fa-grin-tongue-wink"} ,
                {name : "far fa-grin-tongue-wink"} ,
                {name : "fas fa-grin-wink"} ,
                {name : "far fa-grin-wink"} ,
                {name : "fas fa-grip-horizontal"} ,
                {name : "fas fa-grip-lines"} ,
                {name : "fas fa-grip-lines-vertical"} ,
                {name : "fas fa-grip-vertical"} ,
                {name : "fab fa-gripfire"} ,
                {name : "fab fa-grunt"} ,
                {name : "fas fa-guitar"} ,
                {name : "fab fa-gulp"} ,
                {name : "fas fa-h-square"} ,
                {name : "fab fa-hacker-news"} ,
                {name : "fab fa-hacker-news-square"} ,
                {name : "fab fa-hackerrank"} ,
                {name : "fas fa-hamburger"} ,
                {name : "fas fa-hammer"} ,
                {name : "fas fa-hamsa"} ,
                {name : "fas fa-hand-holding"} ,
                {name : "fas fa-hand-holding-heart"} ,
                {name : "fas fa-hand-holding-usd"} ,
                {name : "fas fa-hand-lizard"} ,
                {name : "far fa-hand-lizard"} ,
                {name : "fas fa-hand-middle-finger"} ,
                {name : "fas fa-hand-paper"} ,
                {name : "far fa-hand-paper"} ,
                {name : "fas fa-hand-peace"} ,
                {name : "far fa-hand-peace"} ,
                {name : "fas fa-hand-point-down"} ,
                {name : "far fa-hand-point-down"} ,
                {name : "fas fa-hand-point-left"} ,
                {name : "far fa-hand-point-left"} ,
                {name : "fas fa-hand-point-right"} ,
                {name : "far fa-hand-point-right"} ,
                {name : "fas fa-hand-point-up"} ,
                {name : "far fa-hand-point-up"} ,
                {name : "fas fa-hand-pointer"} ,
                {name : "far fa-hand-pointer"} ,
                {name : "fas fa-hand-rock"} ,
                {name : "far fa-hand-rock"} ,
                {name : "fas fa-hand-scissors"} ,
                {name : "far fa-hand-scissors"} ,
                {name : "fas fa-hand-spock"} ,
                {name : "far fa-hand-spock"} ,
                {name : "fas fa-hands"} ,
                {name : "fas fa-hands-helping"} ,
                {name : "fas fa-handshake"} ,
                {name : "far fa-handshake"} ,
                {name : "fas fa-hanukiah"} ,
                {name : "fas fa-hard-hat"} ,
                {name : "fas fa-hashtag"} ,
                {name : "fas fa-hat-wizard"} ,
                {name : "fas fa-haykal"} ,
                {name : "fas fa-hdd"} ,
                {name : "far fa-hdd"} ,
                {name : "fas fa-heading"} ,
                {name : "fas fa-headphones"} ,
                {name : "fas fa-headphones-alt"} ,
                {name : "fas fa-headset"} ,
                {name : "fas fa-heart"} ,
                {name : "far fa-heart"} ,
                {name : "fas fa-heart-broken"} ,
                {name : "fas fa-heartbeat"} ,
                {name : "fas fa-helicopter"} ,
                {name : "fas fa-highlighter"} ,
                {name : "fas fa-hiking"} ,
                {name : "fas fa-hippo"} ,
                {name : "fab fa-hips"} ,
                {name : "fab fa-hire-a-helper"} ,
                {name : "fas fa-history"} ,
                {name : "fas fa-hockey-puck"} ,
                {name : "fas fa-holly-berry"} ,
                {name : "fas fa-home"} ,
                {name : "fab fa-hooli"} ,
                {name : "fab fa-hornbill"} ,
                {name : "fas fa-horse"} ,
                {name : "fas fa-horse-head"} ,
                {name : "fas fa-hospital"} ,
                {name : "far fa-hospital"} ,
                {name : "fas fa-hospital-alt"} ,
                {name : "fas fa-hospital-symbol"} ,
                {name : "fas fa-hot-tub"} ,
                {name : "fas fa-hotdog"} ,
                {name : "fas fa-hotel"} ,
                {name : "fab fa-hotjar"} ,
                {name : "fas fa-hourglass"} ,
                {name : "far fa-hourglass"} ,
                {name : "fas fa-hourglass-end"} ,
                {name : "fas fa-hourglass-half"} ,
                {name : "fas fa-hourglass-start"} ,
                {name : "fas fa-house-damage"} ,
                {name : "fab fa-houzz"} ,
                {name : "fas fa-hryvnia"} ,
                {name : "fab fa-html5"} ,
                {name : "fab fa-hubspot"} ,
                {name : "fas fa-i-cursor"} ,
                {name : "fas fa-ice-cream"} ,
                {name : "fas fa-icicles"} ,
                {name : "fas fa-id-badge"} ,
                {name : "far fa-id-badge"} ,
                {name : "fas fa-id-card"} ,
                {name : "far fa-id-card"} ,
                {name : "fas fa-id-card-alt"} ,
                {name : "fas fa-igloo"} ,
                {name : "fas fa-image"} ,
                {name : "far fa-image"} ,
                {name : "fas fa-images"} ,
                {name : "far fa-images"} ,
                {name : "fab fa-imdb"} ,
                {name : "fas fa-inbox"} ,
                {name : "fas fa-indent"} ,
                {name : "fas fa-industry"} ,
                {name : "fas fa-infinity"} ,
                {name : "fas fa-info"} ,
                {name : "fas fa-info-circle"} ,
                {name : "fab fa-instagram"} ,
                {name : "fab fa-intercom"} ,
                {name : "fab fa-internet-explorer"} ,
                {name : "fab fa-invision"} ,
                {name : "fab fa-ioxhost"} ,
                {name : "fas fa-italic"} ,
                {name : "fab fa-itunes"} ,
                {name : "fab fa-itunes-note"} ,
                {name : "fab fa-java"} ,
                {name : "fas fa-jedi"} ,
                {name : "fab fa-jedi-order"} ,
                {name : "fab fa-jenkins"} ,
                {name : "fab fa-jira"} ,
                {name : "fab fa-joget"} ,
                {name : "fas fa-joint"} ,
                {name : "fab fa-joomla"} ,
                {name : "fas fa-journal-whills"} ,
                {name : "fab fa-js"} ,
                {name : "fab fa-js-square"} ,
                {name : "fab fa-jsfiddle"} ,
                {name : "fas fa-kaaba"} ,
                {name : "fab fa-kaggle"} ,
                {name : "fas fa-key"} ,
                {name : "fab fa-keybase"} ,
                {name : "fas fa-keyboard"} ,
                {name : "far fa-keyboard"} ,
                {name : "fab fa-keycdn"} ,
                {name : "fas fa-khanda"} ,
                {name : "fab fa-kickstarter"} ,
                {name : "fab fa-kickstarter-k"} ,
                {name : "fas fa-kiss"} ,
                {name : "far fa-kiss"} ,
                {name : "fas fa-kiss-beam"} ,
                {name : "far fa-kiss-beam"} ,
                {name : "fas fa-kiss-wink-heart"} ,
                {name : "far fa-kiss-wink-heart"} ,
                {name : "fas fa-kiwi-bird"} ,
                {name : "fab fa-korvue"} ,
                {name : "fas fa-landmark"} ,
                {name : "fas fa-language"} ,
                {name : "fas fa-laptop"} ,
                {name : "fas fa-laptop-code"} ,
                {name : "fas fa-laptop-medical"} ,
                {name : "fab fa-laravel"} ,
                {name : "fab fa-lastfm"} ,
                {name : "fab fa-lastfm-square"} ,
                {name : "fas fa-laugh"} ,
                {name : "far fa-laugh"} ,
                {name : "fas fa-laugh-beam"} ,
                {name : "far fa-laugh-beam"} ,
                {name : "fas fa-laugh-squint"} ,
                {name : "far fa-laugh-squint"} ,
                {name : "fas fa-laugh-wink"} ,
                {name : "far fa-laugh-wink"} ,
                {name : "fas fa-layer-group"} ,
                {name : "fas fa-leaf"} ,
                {name : "fab fa-leanpub"} ,
                {name : "fas fa-lemon"} ,
                {name : "far fa-lemon"} ,
                {name : "fab fa-less"} ,
                {name : "fas fa-less-than"} ,
                {name : "fas fa-less-than-equal"} ,
                {name : "fas fa-level-down-alt"} ,
                {name : "fas fa-level-up-alt"} ,
                {name : "fas fa-life-ring"} ,
                {name : "far fa-life-ring"} ,
                {name : "fas fa-lightbulb"} ,
                {name : "far fa-lightbulb"} ,
                {name : "fab fa-line"} ,
                {name : "fas fa-link"} ,
                {name : "fab fa-linkedin"} ,
                {name : "fab fa-linkedin-in"} ,
                {name : "fab fa-linode"} ,
                {name : "fab fa-linux"} ,
                {name : "fas fa-lira-sign"} ,
                {name : "fas fa-list"} ,
                {name : "fas fa-list-alt"} ,
                {name : "far fa-list-alt"} ,
                {name : "fas fa-list-ol"} ,
                {name : "fas fa-list-ul"} ,
                {name : "fas fa-location-arrow"} ,
                {name : "fas fa-lock"} ,
                {name : "fas fa-lock-open"} ,
                {name : "fas fa-long-arrow-alt-down"} ,
                {name : "fas fa-long-arrow-alt-left"} ,
                {name : "fas fa-long-arrow-alt-right"} ,
                {name : "fas fa-long-arrow-alt-up"} ,
                {name : "fas fa-low-vision"} ,
                {name : "fas fa-luggage-cart"} ,
                {name : "fab fa-lyft"} ,
                {name : "fab fa-magento"} ,
                {name : "fas fa-magic"} ,
                {name : "fas fa-magnet"} ,
                {name : "fas fa-mail-bulk"} ,
                {name : "fab fa-mailchimp"} ,
                {name : "fas fa-male"} ,
                {name : "fab fa-mandalorian"} ,
                {name : "fas fa-map"} ,
                {name : "far fa-map"} ,
                {name : "fas fa-map-marked"} ,
                {name : "fas fa-map-marked-alt"} ,
                {name : "fas fa-map-marker"} ,
                {name : "fas fa-map-marker-alt"} ,
                {name : "fas fa-map-pin"} ,
                {name : "fas fa-map-signs"} ,
                {name : "fab fa-markdown"} ,
                {name : "fas fa-marker"} ,
                {name : "fas fa-mars"} ,
                {name : "fas fa-mars-double"} ,
                {name : "fas fa-mars-stroke"} ,
                {name : "fas fa-mars-stroke-h"} ,
                {name : "fas fa-mars-stroke-v"} ,
                {name : "fas fa-mask"} ,
                {name : "fab fa-mastodon"} ,
                {name : "fab fa-maxcdn"} ,
                {name : "fas fa-medal"} ,
                {name : "fab fa-medapps"} ,
                {name : "fab fa-medium"} ,
                {name : "fab fa-medium-m"} ,
                {name : "fas fa-medkit"} ,
                {name : "fab fa-medrt"} ,
                {name : "fab fa-meetup"} ,
                {name : "fab fa-megaport"} ,
                {name : "fas fa-meh"} ,
                {name : "far fa-meh"} ,
                {name : "fas fa-meh-blank"} ,
                {name : "far fa-meh-blank"} ,
                {name : "fas fa-meh-rolling-eyes"} ,
                {name : "far fa-meh-rolling-eyes"} ,
                {name : "fas fa-memory"} ,
                {name : "fab fa-mendeley"} ,
                {name : "fas fa-menorah"} ,
                {name : "fas fa-mercury"} ,
                {name : "fas fa-meteor"} ,
                {name : "fas fa-microchip"} ,
                {name : "fas fa-microphone"} ,
                {name : "fas fa-microphone-alt"} ,
                {name : "fas fa-microphone-alt-slash"} ,
                {name : "fas fa-microphone-slash"} ,
                {name : "fas fa-microscope"} ,
                {name : "fab fa-microsoft"} ,
                {name : "fas fa-minus"} ,
                {name : "fas fa-minus-circle"} ,
                {name : "fas fa-minus-square"} ,
                {name : "far fa-minus-square"} ,
                {name : "fas fa-mitten"} ,
                {name : "fab fa-mix"} ,
                {name : "fab fa-mixcloud"} ,
                {name : "fab fa-mizuni"} ,
                {name : "fas fa-mobile"} ,
                {name : "fas fa-mobile-alt"} ,
                {name : "fab fa-modx"} ,
                {name : "fab fa-monero"} ,
                {name : "fas fa-money-bill"} ,
                {name : "fas fa-money-bill-alt"} ,
                {name : "far fa-money-bill-alt"} ,
                {name : "fas fa-money-bill-wave"} ,
                {name : "fas fa-money-bill-wave-alt"} ,
                {name : "fas fa-money-check"} ,
                {name : "fas fa-money-check-alt"} ,
                {name : "fas fa-monument"} ,
                {name : "fas fa-moon"} ,
                {name : "far fa-moon"} ,
                {name : "fas fa-mortar-pestle"} ,
                {name : "fas fa-mosque"} ,
                {name : "fas fa-motorcycle"} ,
                {name : "fas fa-mountain"} ,
                {name : "fas fa-mouse-pointer"} ,
                {name : "fas fa-mug-hot"} ,
                {name : "fas fa-music"} ,
                {name : "fab fa-napster"} ,
                {name : "fab fa-neos"} ,
                {name : "fas fa-network-wired"} ,
                {name : "fas fa-neuter"} ,
                {name : "fas fa-newspaper"} ,
                {name : "far fa-newspaper"} ,
                {name : "fab fa-nimblr"} ,
                {name : "fab fa-nintendo-switch"} ,
                {name : "fab fa-node"} ,
                {name : "fab fa-node-js"} ,
                {name : "fas fa-not-equal"} ,
                {name : "fas fa-notes-medical"} ,
                {name : "fab fa-npm"} ,
                {name : "fab fa-ns8"} ,
                {name : "fab fa-nutritionix"} ,
                {name : "fas fa-object-group"} ,
                {name : "far fa-object-group"} ,
                {name : "fas fa-object-ungroup"} ,
                {name : "far fa-object-ungroup"} ,
                {name : "fab fa-odnoklassniki"} ,
                {name : "fab fa-odnoklassniki-square"} ,
                {name : "fas fa-oil-can"} ,
                {name : "fab fa-old-republic"} ,
                {name : "fas fa-om"} ,
                {name : "fab fa-opencart"} ,
                {name : "fab fa-openid"} ,
                {name : "fab fa-opera"} ,
                {name : "fab fa-optin-monster"} ,
                {name : "fab fa-osi"} ,
                {name : "fas fa-otter"} ,
                {name : "fas fa-outdent"} ,
                {name : "fab fa-page4"} ,
                {name : "fab fa-pagelines"} ,
                {name : "fas fa-pager"} ,
                {name : "fas fa-paint-brush"} ,
                {name : "fas fa-paint-roller"} ,
                {name : "fas fa-palette"} ,
                {name : "fab fa-palfed"} ,
                {name : "fas fa-pallet"} ,
                {name : "fas fa-paper-plane"} ,
                {name : "far fa-paper-plane"} ,
                {name : "fas fa-paperclip"} ,
                {name : "fas fa-parachute-box"} ,
                {name : "fas fa-paragraph"} ,
                {name : "fas fa-parking"} ,
                {name : "fas fa-passport"} ,
                {name : "fas fa-pastafarianism"} ,
                {name : "fas fa-paste"} ,
                {name : "fab fa-patreon"} ,
                {name : "fas fa-pause"} ,
                {name : "fas fa-pause-circle"} ,
                {name : "far fa-pause-circle"} ,
                {name : "fas fa-paw"} ,
                {name : "fab fa-paypal"} ,
                {name : "fas fa-peace"} ,
                {name : "fas fa-pen"} ,
                {name : "fas fa-pen-alt"} ,
                {name : "fas fa-pen-fancy"} ,
                {name : "fas fa-pen-nib"} ,
                {name : "fas fa-pen-square"} ,
                {name : "fas fa-pencil-alt"} ,
                {name : "fas fa-pencil-ruler"} ,
                {name : "fab fa-penny-arcade"} ,
                {name : "fas fa-people-carry"} ,
                {name : "fas fa-pepper-hot"} ,
                {name : "fas fa-percent"} ,
                {name : "fas fa-percentage"} ,
                {name : "fab fa-periscope"} ,
                {name : "fas fa-person-booth"} ,
                {name : "fab fa-phabricator"} ,
                {name : "fab fa-phoenix-framework"} ,
                {name : "fab fa-phoenix-squadron"} ,
                {name : "fas fa-phone"} ,
                {name : "fas fa-phone-slash"} ,
                {name : "fas fa-phone-square"} ,
                {name : "fas fa-phone-volume"} ,
                {name : "fab fa-php"} ,
                {name : "fab fa-pied-piper"} ,
                {name : "fab fa-pied-piper-alt"} ,
                {name : "fab fa-pied-piper-hat"} ,
                {name : "fab fa-pied-piper-pp"} ,
                {name : "fas fa-piggy-bank"} ,
                {name : "fas fa-pills"} ,
                {name : "fab fa-pinterest"} ,
                {name : "fab fa-pinterest-p"} ,
                {name : "fab fa-pinterest-square"} ,
                {name : "fas fa-pizza-slice"} ,
                {name : "fas fa-place-of-worship"} ,
                {name : "fas fa-plane"} ,
                {name : "fas fa-plane-arrival"} ,
                {name : "fas fa-plane-departure"} ,
                {name : "fas fa-play"} ,
                {name : "fas fa-play-circle"} ,
                {name : "far fa-play-circle"} ,
                {name : "fab fa-playstation"} ,
                {name : "fas fa-plug"} ,
                {name : "fas fa-plus"} ,
                {name : "fas fa-plus-circle"} ,
                {name : "fas fa-plus-square"} ,
                {name : "far fa-plus-square"} ,
                {name : "fas fa-podcast"} ,
                {name : "fas fa-poll"} ,
                {name : "fas fa-poll-h"} ,
                {name : "fas fa-poo"} ,
                {name : "fas fa-poo-storm"} ,
                {name : "fas fa-poop"} ,
                {name : "fas fa-portrait"} ,
                {name : "fas fa-pound-sign"} ,
                {name : "fas fa-power-off"} ,
                {name : "fas fa-pray"} ,
                {name : "fas fa-praying-hands"} ,
                {name : "fas fa-prescription"} ,
                {name : "fas fa-prescription-bottle"} ,
                {name : "fas fa-prescription-bottle-alt"} ,
                {name : "fas fa-print"} ,
                {name : "fas fa-procedures"} ,
                {name : "fab fa-product-hunt"} ,
                {name : "fas fa-project-diagram"} ,
                {name : "fab fa-pushed"} ,
                {name : "fas fa-puzzle-piece"} ,
                {name : "fab fa-python"} ,
                {name : "fab fa-qq"} ,
                {name : "fas fa-qrcode"} ,
                {name : "fas fa-question"} ,
                {name : "fas fa-question-circle"} ,
                {name : "far fa-question-circle"} ,
                {name : "fas fa-quidditch"} ,
                {name : "fab fa-quinscape"} ,
                {name : "fab fa-quora"} ,
                {name : "fas fa-quote-left"} ,
                {name : "fas fa-quote-right"} ,
                {name : "fas fa-quran"} ,
                {name : "fab fa-r-project"} ,
                {name : "fas fa-radiation"} ,
                {name : "fas fa-radiation-alt"} ,
                {name : "fas fa-rainbow"} ,
                {name : "fas fa-random"} ,
                {name : "fab fa-raspberry-pi"} ,
                {name : "fab fa-ravelry"} ,
                {name : "fab fa-react"} ,
                {name : "fab fa-reacteurope"} ,
                {name : "fab fa-readme"} ,
                {name : "fab fa-rebel"} ,
                {name : "fas fa-receipt"} ,
                {name : "fas fa-recycle"} ,
                {name : "fab fa-red-river"} ,
                {name : "fab fa-reddit"} ,
                {name : "fab fa-reddit-alien"} ,
                {name : "fab fa-reddit-square"} ,
                {name : "fab fa-redhat"} ,
                {name : "fas fa-redo"} ,
                {name : "fas fa-redo-alt"} ,
                {name : "fas fa-registered"} ,
                {name : "far fa-registered"} ,
                {name : "fab fa-renren"} ,
                {name : "fas fa-reply"} ,
                {name : "fas fa-reply-all"} ,
                {name : "fab fa-replyd"} ,
                {name : "fas fa-republican"} ,
                {name : "fab fa-researchgate"} ,
                {name : "fab fa-resolving"} ,
                {name : "fas fa-restroom"} ,
                {name : "fas fa-retweet"} ,
                {name : "fab fa-rev"} ,
                {name : "fas fa-ribbon"} ,
                {name : "fas fa-ring"} ,
                {name : "fas fa-road"} ,
                {name : "fas fa-robot"} ,
                {name : "fas fa-rocket"} ,
                {name : "fab fa-rocketchat"} ,
                {name : "fab fa-rockrms"} ,
                {name : "fas fa-route"} ,
                {name : "fas fa-rss"} ,
                {name : "fas fa-rss-square"} ,
                {name : "fas fa-ruble-sign"} ,
                {name : "fas fa-ruler"} ,
                {name : "fas fa-ruler-combined"} ,
                {name : "fas fa-ruler-horizontal"} ,
                {name : "fas fa-ruler-vertical"} ,
                {name : "fas fa-running"} ,
                {name : "fas fa-rupee-sign"} ,
                {name : "fas fa-sad-cry"} ,
                {name : "far fa-sad-cry"} ,
                {name : "fas fa-sad-tear"} ,
                {name : "far fa-sad-tear"} ,
                {name : "fab fa-safari"} ,
                {name : "fab fa-sass"} ,
                {name : "fas fa-satellite"} ,
                {name : "fas fa-satellite-dish"} ,
                {name : "fas fa-save"} ,
                {name : "far fa-save"} ,
                {name : "fab fa-schlix"} ,
                {name : "fas fa-school"} ,
                {name : "fas fa-screwdriver"} ,
                {name : "fab fa-scribd"} ,
                {name : "fas fa-scroll"} ,
                {name : "fas fa-sd-card"} ,
                {name : "fas fa-search"} ,
                {name : "fas fa-search-dollar"} ,
                {name : "fas fa-search-location"} ,
                {name : "fas fa-search-minus"} ,
                {name : "fas fa-search-plus"} ,
                {name : "fab fa-searchengin"} ,
                {name : "fas fa-seedling"} ,
                {name : "fab fa-sellcast"} ,
                {name : "fab fa-sellsy"} ,
                {name : "fas fa-server"} ,
                {name : "fab fa-servicestack"} ,
                {name : "fas fa-shapes"} ,
                {name : "fas fa-share"} ,
                {name : "fas fa-share-alt"} ,
                {name : "fas fa-share-alt-square"} ,
                {name : "fas fa-share-square"} ,
                {name : "far fa-share-square"} ,
                {name : "fas fa-shekel-sign"} ,
                {name : "fas fa-shield-alt"} ,
                {name : "fas fa-ship"} ,
                {name : "fas fa-shipping-    {name : fast"} ,
                {name : "fab fa-shirtsinbulk"} ,
                {name : "fas fa-shoe-prints"} ,
                {name : "fas fa-shopping-bag"} ,
                {name : "fas fa-shopping-basket"} ,
                {name : "fas fa-shopping-cart"} ,
                {name : "fab fa-shopware"} ,
                {name : "fas fa-shower"} ,
                {name : "fas fa-shuttle-van"} ,
                {name : "fas fa-sign"} ,
                {name : "fas fa-sign-in-alt"} ,
                {name : "fas fa-sign-language"} ,
                {name : "fas fa-sign-out-alt"} ,
                {name : "fas fa-signal"} ,
                {name : "fas fa-signature"} ,
                {name : "fas fa-sim-card"} ,
                {name : "fab fa-simplybuilt"} ,
                {name : "fab fa-sistrix"} ,
                {name : "fas fa-sitemap"} ,
                {name : "fab fa-sith"} ,
                {name : "fas fa-skating"} ,
                {name : "fab fa-sketch"} ,
                {name : "fas fa-skiing"} ,
                {name : "fas fa-skiing-nordic"} ,
                {name : "fas fa-skull"} ,
                {name : "fas fa-skull-crossbones"} ,
                {name : "fab fa-skyatlas"} ,
                {name : "fab fa-skype"} ,
                {name : "fab fa-slack"} ,
                {name : "fab fa-slack-hash"} ,
                {name : "fas fa-slash"} ,
                {name : "fas fa-sleigh"} ,
                {name : "fas fa-sliders-h"} ,
                {name : "fab fa-slideshare"} ,
                {name : "fas fa-smile"} ,
                {name : "far fa-smile"} ,
                {name : "fas fa-smile-beam"} ,
                {name : "far fa-smile-beam"} ,
                {name : "fas fa-smile-wink"} ,
                {name : "far fa-smile-wink"} ,
                {name : "fas fa-smog"} ,
                {name : "fas fa-smoking"} ,
                {name : "fas fa-smoking-ban"} ,
                {name : "fas fa-sms"} ,
                {name : "fab fa-snapchat"} ,
                {name : "fab fa-snapchat-ghost"} ,
                {name : "fab fa-snapchat-square"} ,
                {name : "fas fa-snowboarding"} ,
                {name : "fas fa-snowflake"} ,
                {name : "far fa-snowflake"} ,
                {name : "fas fa-snowman"} ,
                {name : "fas fa-snowplow"} ,
                {name : "fas fa-socks"} ,
                {name : "fas fa-solar-panel"} ,
                {name : "fas fa-sort"} ,
                {name : "fas fa-sort-alpha-down"} ,
                {name : "fas fa-sort-alpha-up"} ,
                {name : "fas fa-sort-amount-down"} ,
                {name : "fas fa-sort-amount-up"} ,
                {name : "fas fa-sort-down"} ,
                {name : "fas fa-sort-numeric-down"} ,
                {name : "fas fa-sort-numeric-up"} ,
                {name : "fas fa-sort-up"} ,
                {name : "fab fa-soundcloud"} ,
                {name : "fab fa-sourcetree"} ,
                {name : "fas fa-spa"} ,
                {name : "fas fa-space-shuttle"} ,
                {name : "fab fa-speakap"} ,
                {name : "fas fa-spider"} ,
                {name : "fas fa-spinner"} ,
                {name : "fas fa-splotch"} ,
                {name : "fab fa-spotify"} ,
                {name : "fas fa-spray-can"} ,
                {name : "fas fa-square"} ,
                {name : "far fa-square"} ,
                {name : "fas fa-square-full"} ,
                {name : "fas fa-square-root-alt"} ,
                {name : "fab fa-squarespace"} ,
                {name : "fab fa-stack-exchange"} ,
                {name : "fab fa-stack-overflow"} ,
                {name : "fas fa-stamp"} ,
                {name : "fas fa-star"} ,
                {name : "far fa-star"} ,
                {name : "fas fa-star-and-crescent"} ,
                {name : "fas fa-star-half"} ,
                {name : "far fa-star-half"} ,
                {name : "fas fa-star-half-alt"} ,
                {name : "fas fa-star-of-david"} ,
                {name : "fas fa-star-of-life"} ,
                {name : "fab fa-staylinked"} ,
                {name : "fab fa-steam"} ,
                {name : "fab fa-steam-square"} ,
                {name : "fab fa-steam-symbol"} ,
                {name : "fas fa-step-backward"} ,
                {name : "fas fa-step-forward"} ,
                {name : "fas fa-stethoscope"} ,
                {name : "fab fa-sticker-mule"} ,
                {name : "fas fa-sticky-note"} ,
                {name : "far fa-sticky-note"} ,
                {name : "fas fa-stop"} ,
                {name : "fas fa-stop-circle"} ,
                {name : "far fa-stop-circle"} ,
                {name : "fas fa-stopwatch"} ,
                {name : "fas fa-store"} ,
                {name : "fas fa-store-alt"} ,
                {name : "fab fa-strava"} ,
                {name : "fas fa-stream"} ,
                {name : "fas fa-street-view"} ,
                {name : "fas fa-strikethrough"} ,
                {name : "fab fa-stripe"} ,
                {name : "fab fa-stripe-s"} ,
                {name : "fas fa-stroopwafel"} ,
                {name : "fab fa-studiovinari"} ,
                {name : "fab fa-stumbleupon"} ,
                {name : "fab fa-stumbleupon-circle"} ,
                {name : "fas fa-subscript"} ,
                {name : "fas fa-subway"} ,
                {name : "fas fa-suitcase"} ,
                {name : "fas fa-suitcase-rolling"} ,
                {name : "fas fa-sun"} ,
                {name : "far fa-sun"} ,
                {name : "fab fa-superpowers"} ,
                {name : "fas fa-superscript"} ,
                {name : "fab fa-supple"} ,
                {name : "fas fa-surprise"} ,
                {name : "far fa-surprise"} ,
                {name : "fab fa-suse"} ,
                {name : "fas fa-swatchbook"} ,
                {name : "fas fa-swimmer"} ,
                {name : "fas fa-swimming-pool"} ,
                {name : "fas fa-synagogue"} ,
                {name : "fas fa-sync"} ,
                {name : "fas fa-sync-alt"} ,
                {name : "fas fa-syringe"} ,
                {name : "fas fa-table"} ,
                {name : "fas fa-table-tennis"} ,
                {name : "fas fa-tablet"} ,
                {name : "fas fa-tablet-alt"} ,
                {name : "fas fa-tablets"} ,
                {name : "fas fa-tachometer-alt"} ,
                {name : "fas fa-tag"} ,
                {name : "fas fa-tags"} ,
                {name : "fas fa-tape"} ,
                {name : "fas fa-tasks"} ,
                {name : "fas fa-taxi"} ,
                {name : "fab fa-teamspeak"} ,
                {name : "fas fa-teeth"} ,
                {name : "fas fa-teeth-open"} ,
                {name : "fab fa-telegram"} ,
                {name : "fab fa-telegram-plane"} ,
                {name : "fas fa-temperature-high"} ,
                {name : "fas fa-temperature-low"} ,
                {name : "fab fa-tencent-weibo"} ,
                {name : "fas fa-tenge"} ,
                {name : "fas fa-terminal"} ,
                {name : "fas fa-text-height"} ,
                {name : "fas fa-text-width"} ,
                {name : "fas fa-th"} ,
                {name : "fas fa-th-large"} ,
                {name : "fas fa-th-list"} ,
                {name : "fab fa-the-red-yeti"} ,
                {name : "fas fa-theater-masks"} ,
                {name : "fab fa-themeco"} ,
                {name : "fab fa-themeisle"} ,
                {name : "fas fa-thermometer"} ,
                {name : "fas fa-thermometer-empty"} ,
                {name : "fas fa-thermometer-full"} ,
                {name : "fas fa-thermometer-half"} ,
                {name : "fas fa-thermometer-quarter"} ,
                {name : "fas fa-thermometer-three-quarters"} ,
                {name : "fab fa-think-peaks"} ,
                {name : "fas fa-thumbs-down"} ,
                {name : "far fa-thumbs-down"} ,
                {name : "fas fa-thumbs-up"} ,
                {name : "far fa-thumbs-up"} ,
                {name : "fas fa-thumbtack"} ,
                {name : "fas fa-ticket-alt"} ,
                {name : "fas fa-times"} ,
                {name : "fas fa-times-circle"} ,
                {name : "far fa-times-circle"} ,
                {name : "fas fa-tint"} ,
                {name : "fas fa-tint-slash"} ,
                {name : "fas fa-tired"} ,
                {name : "far fa-tired"} ,
                {name : "fas fa-toggle-off"} ,
                {name : "fas fa-toggle-on"} ,
                {name : "fas fa-toilet"} ,
                {name : "fas fa-toilet-paper"} ,
                {name : "fas fa-toolbox"} ,
                {name : "fas fa-tools"} ,
                {name : "fas fa-tooth"} ,
                {name : "fas fa-torah"} ,
                {name : "fas fa-torii-gate"} ,
                {name : "fas fa-tractor"} ,
                {name : "fab fa-trade-federation"} ,
                {name : "fas fa-trademark"} ,
                {name : "fas fa-traffic-light"} ,
                {name : "fas fa-train"} ,
                {name : "fas fa-tram"} ,
                {name : "fas fa-transgender"} ,
                {name : "fas fa-transgender-alt"} ,
                {name : "fas fa-trash"} ,
                {name : "fas fa-trash-alt"} ,
                {name : "far fa-trash-alt"} ,
                {name : "fas fa-trash-restore"} ,
                {name : "fas fa-trash-restore-alt"} ,
                {name : "fas fa-tree"} ,
                {name : "fab fa-trello"} ,
                {name : "fab fa-tripadvisor"} ,
                {name : "fas fa-trophy"} ,
                {name : "fas fa-truck"} ,
                {name : "fas fa-truck-loading"} ,
                {name : "fas fa-truck-monster"} ,
                {name : "fas fa-truck-moving"} ,
                {name : "fas fa-truck-pickup"} ,
                {name : "fas fa-tshirt"} ,
                {name : "fas fa-tty"} ,
                {name : "fab fa-tumblr"} ,
                {name : "fab fa-tumblr-square"} ,
                {name : "fas fa-tv"} ,
                {name : "fab fa-twitch"} ,
                {name : "fab fa-twitter"} ,
                {name : "fab fa-twitter-square"} ,
                {name : "fab fa-typo3"} ,
                {name : "fab fa-uber"} ,
                {name : "fab fa-ubuntu"} ,
                {name : "fab fa-uikit"} ,
                {name : "fas fa-umbrella"} ,
                {name : "fas fa-umbrella-beach"} ,
                {name : "fas fa-underline"} ,
                {name : "fas fa-undo"} ,
                {name : "fas fa-undo-alt"} ,
                {name : "fab fa-uniregistry"} ,
                {name : "fas fa-universal-access"} ,
                {name : "fas fa-university"} ,
                {name : "fas fa-unlink"} ,
                {name : "fas fa-unlock"} ,
                {name : "fas fa-unlock-alt"} ,
                {name : "fab fa-untappd"} ,
                {name : "fas fa-upload"} ,
                {name : "fab fa-ups"} ,
                {name : "fab fa-usb"} ,
                {name : "fas fa-user"} ,
                {name : "far fa-user"} ,
                {name : "fas fa-user-alt"} ,
                {name : "fas fa-user-alt-slash"} ,
                {name : "fas fa-user-astronaut"} ,
                {name : "fas fa-user-check"} ,
                {name : "fas fa-user-circle"} ,
                {name : "far fa-user-circle"} ,
                {name : "fas fa-user-clock"} ,
                {name : "fas fa-user-cog"} ,
                {name : "fas fa-user-edit"} ,
                {name : "fas fa-user-friends"} ,
                {name : "fas fa-user-graduate"} ,
                {name : "fas fa-user-injured"} ,
                {name : "fas fa-user-lock"} ,
                {name : "fas fa-user-md"} ,
                {name : "fas fa-user-minus"} ,
                {name : "fas fa-user-ninja"} ,
                {name : "fas fa-user-nurse"} ,
                {name : "fas fa-user-plus"} ,
                {name : "fas fa-user-secret"} ,
                {name : "fas fa-user-shield"} ,
                {name : "fas fa-user-slash"} ,
                {name : "fas fa-user-tag"} ,
                {name : "fas fa-user-tie"} ,
                {name : "fas fa-user-times"} ,
                {name : "fas fa-users"} ,
                {name : "fas fa-users-cog"} ,
                {name : "fab fa-usps"} ,
                {name : "fab fa-ussunnah"} ,
                {name : "fas fa-utensil-spoon"} ,
                {name : "fas fa-utensils"} ,
                {name : "fab fa-vaadin"} ,
                {name : "fas fa-vector-square"} ,
                {name : "fas fa-venus"} ,
                {name : "fas fa-venus-double"} ,
                {name : "fas fa-venus-mars"} ,
                {name : "fab fa-viacoin"} ,
                {name : "fab fa-viadeo"} ,
                {name : "fab fa-viadeo-square"} ,
                {name : "fas fa-vial"} ,
                {name : "fas fa-vials"} ,
                {name : "fab fa-viber"} ,
                {name : "fas fa-video"} ,
                {name : "fas fa-video-slash"} ,
                {name : "fas fa-vihara"} ,
                {name : "fab fa-vimeo"} ,
                {name : "fab fa-vimeo-square"} ,
                {name : "fab fa-vimeo-v"} ,
                {name : "fab fa-vine"} ,
                {name : "fab fa-vk"} ,
                {name : "fab fa-vnv"} ,
                {name : "fas fa-volleyball-ball"} ,
                {name : "fas fa-volume-down"} ,
                {name : "fas fa-volume-mute"} ,
                {name : "fas fa-volume-off"} ,
                {name : "fas fa-volume-up"} ,
                {name : "fas fa-vote-yea"} ,
                {name : "fas fa-vr-cardboard"} ,
                {name : "fab fa-vuejs"} ,
                {name : "fas fa-walking"} ,
                {name : "fas fa-wallet"} ,
                {name : "fas fa-warehouse"} ,
                {name : "fas fa-water"} ,
                {name : "fab fa-weebly"} ,
                {name : "fab fa-weibo"} ,
                {name : "fas fa-weight"} ,
                {name : "fas fa-weight-hanging"} ,
                {name : "fab fa-weixin"} ,
                {name : "fab fa-whatsapp"} ,
                {name : "fab fa-whatsapp-square"} ,
                {name : "fas fa-wheelchair"} ,
                {name : "fab fa-whmcs"} ,
                {name : "fas fa-wifi"} ,
                {name : "fab fa-wikipedia-w"} ,
                {name : "fas fa-wind"} ,
                {name : "fas fa-window-close"} ,
                {name : "far fa-window-close"} ,
                {name : "fas fa-window-maximize"} ,
                {name : "far fa-window-maximize"} ,
                {name : "fas fa-window-minimize"} ,
                {name : "far fa-window-minimize"} ,
                {name : "fas fa-window-restore"} ,
                {name : "far fa-window-restore"} ,
                {name : "fab fa-windows"} ,
                {name : "fas fa-wine-bottle"} ,
                {name : "fas fa-wine-glass"} ,
                {name : "fas fa-wine-glass-alt"} ,
                {name : "fab fa-wix"} ,
                {name : "fab fa-wizards-of-the-coast"} ,
                {name : "fab fa-wolf-pack-battalion"} ,
                {name : "fas fa-won-sign"} ,
                {name : "fab fa-wordpress"} ,
                {name : "fab fa-wordpress-simple"} ,
                {name : "fab fa-wpbeginner"} ,
                {name : "fab fa-wpexplorer"} ,
                {name : "fab fa-wpforms"} ,
                {name : "fab fa-wpressr"} ,
                {name : "fas fa-wrench"} ,
                {name : "fas fa-x-ray"} ,
                {name : "fab fa-xbox"} ,
                {name : "fab fa-xing"} ,
                {name : "fab fa-xing-square"} ,
                {name : "fab fa-y-combinator"} ,
                {name : "fab fa-yahoo"} ,
                {name : "fab fa-yandex"} ,
                {name : "fab fa-yandex-international"} ,
                {name : "fab fa-yarn"} ,
                {name : "fab fa-yelp"} ,
                {name : "fas fa-yen-sign"} ,
                {name : "fas fa-yin-yang"} ,
                {name : "fab fa-yoast"} ,
                {name : "fab fa-youtube"} ,
                {name : "fab fa-youtube-square"} ,
                {name : "fab fa-zhihu"}
            ],
            searchTerm: '',
            asToggleBoxUse: true
        }
    },

    methods: {

        toggleIcons() {

            document.addEventListener("click", this.documentClick)

        },

        documentClick(event) {

			var el = this.$refs.iconPicker,
                target = event.target

			if(el !== target && !el.contains(target)) {

                el.classList.add('use-as-togglebox')
                document.removeEventListener('click', this.documentClick)

            } else {
                el.classList.remove('use-as-togglebox')
            }
        },

        // set icon to Weebly and set active class
        selectIcon(event) {
            if(document.querySelector('.my-icon-picker--icons .active') !== null) {
                document.querySelector('.my-icon-picker--icons .active').classList.remove('active')
            }

            this.selectedIcon = event.target.className
            event.target.classList.add('active')

            this.$store.state.weeblySettings.settings.iconClass = event.target.className

            console.log('selected icon ',this.selectedIcon)
            
        }
    },
    computed: {

        filteredIcons() {
            return this.icons.filter(icon => {
                return icon.name.toLowerCase().match(this.searchTerm.toLowerCase())
            })
        },

        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        }

    },

    mounted() {

        // set active icon
        this.selectedIcon = this.$props.setActiveIcon
        console.log(this.$props.setActiveIcon)

        this.$props.asToggleBox === 'true' ? this.asToggleBoxUse = true : this.asToggleBoxUse = false

    }

}
</script>

<style lang="less">
@import '../../../less/colors.less';

.my-icon-picker {
    width: 100%;
    max-width: 400px;
    border-radius: 3px;
    margin: 15px 0;
}

.my-icon-picker--icons {
    display: flex;
    flex-wrap: wrap;
    margin-top: 5px;
    height: 100%;
    max-height: 250px;
    overflow-y: auto;
    transition: all .3s ease-out;
    background: @white;
    border: 1px solid @border_grey_dark;
    border-radius: .25rem;
    padding: 5px;
    box-shadow: 0 4px 10px fade(@border_grey_dark,30%);

    i {
        width: 22%;
        margin: 1.5%;
        border: 1px solid @border_grey;
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-size: 17px;
        cursor: pointer;
        border-radius: 3px;

        &:hover, &.active {
            border-color: @action_blue;
            
        }
    }
}

.use-as-togglebox .my-icon-picker--icons {
    max-height: 0;
    padding: 0;
    border: 0;
}

.search-filter-input {
    display: flex;
    flex-wrap: wrap;
    padding: 0;

    input {
        flex: 1;
    }

    .active-icon {
        width: 50px;
        text-align: center;
        width: 50px;
        text-align: center;
        margin-left: 5px;
        border: 1px solid @action_blue;
        border-radius: .25rem;
        line-height: 31px;
        color: @action_blue;
        background: @white;
        height: 31px;
    }
}

</style>




// WEBPACK FOOTER //
// src/components/elements/elementSettings/Iconpicker.vue